<section class="lb-search">
  <i class="icon codere-icon icon-search" name="search"></i>
  <input class="input" #searchInput [(ngModel)]="term" [ngClass]="currentFilterIndex ? 'color-dark' : 'color-light'" />
</section>
